var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23603_14661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 4.16663C15.2212 4.16663 15.4331 4.25442 15.5894 4.4107C15.7457 4.56698 15.8335 4.77895 15.8335 4.99996V11.6666C15.8335 11.8876 15.7457 12.0996 15.5894 12.2559C15.4331 12.4122 15.2212 12.5 15.0002 12.5C14.7791 12.5 14.5672 12.4122 14.4109 12.2559C14.2546 12.0996 14.1668 11.8876 14.1668 11.6666V7.01163L5.87515 15.3033C5.71798 15.4551 5.50748 15.5391 5.28898 15.5372C5.07049 15.5353 4.86147 15.4476 4.70697 15.2931C4.55246 15.1386 4.46482 14.9296 4.46292 14.7111C4.46102 14.4926 4.54502 14.2821 4.69682 14.125L12.9885 5.83329H8.33348C8.11247 5.83329 7.90051 5.7455 7.74423 5.58921C7.58795 5.43293 7.50015 5.22097 7.50015 4.99996C7.50015 4.77895 7.58795 4.56698 7.74423 4.4107C7.90051 4.25442 8.11247 4.16663 8.33348 4.16663H15.0002Z",
    fill: "#F77C47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23603_14661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.3718035d36d83ef79454d2ba21c40013.svg";
export { ForwardRef as ReactComponent };